import React from "react";
import { motion } from "framer-motion";
import { LOGO_SRC } from "../constants/branding";

/**
 * Full-screen loader aligned with landing / login (#131313, primary, logo).
 * @param {string} [props.title] - Short heading (English UI)
 * @param {string} [props.subtitle] - Supporting line
 */
const LoadingScreen = ({ title = "Please wait", subtitle = "Loading…" }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999] flex min-h-screen flex-col items-center justify-center bg-[#131313] text-white"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {/* Same ambient treatment as Login.jsx / landing */}
      <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true">
        <div className="absolute inset-0 bg-[#131313]" />
        <div className="absolute -left-1/4 top-0 h-[min(70vh,520px)] w-[min(90vw,720px)] rounded-full bg-primary/[0.07] blur-[100px]" />
        <div className="absolute bottom-0 right-0 h-[min(50vh,400px)] w-[min(80vw,560px)] rounded-full bg-emerald-500/[0.05] blur-[90px]" />
      </div>

      <div className="relative z-10 flex max-w-md flex-col items-center px-6 text-center">
        <motion.img
          src={LOGO_SRC}
          alt="DataNodes"
          width={127}
          height={41}
          className="mb-8 h-10 w-auto sm:h-11"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        />

        <motion.div
          className="mb-6 h-12 w-12 rounded-full border-2 border-white/10 border-t-primary"
          animate={{ rotate: 360 }}
          transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}
          aria-hidden
        />

        <motion.h1
          className="font-title text-xl font-bold tracking-tight text-white sm:text-2xl"
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.4 }}
        >
          {title}
        </motion.h1>
        <motion.p
          className="font-secondary mt-2 text-[15px] leading-relaxed text-white/65"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
        >
          {subtitle}
        </motion.p>
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
